<payarc-page-header title="Statements"></payarc-page-header>

<payarc-filter-bar class="st-filter-row">
  <input [matDatepicker]="dp" startView="multi-year" [(ngModel)]="from_date" (click)="dp.open()"
         class="pa-input" style="width:150px" placeholder="From" aria-label="From month" readonly>
  <mat-datepicker #dp startView="multi-year" (monthSelected)="onFromMonthSelected($event, dp)" (closed)="openAdfReport()"></mat-datepicker>
  <input [matDatepicker]="dt" startView="multi-year" [(ngModel)]="to_date" (click)="dt.open()"
         class="pa-input" style="width:150px" placeholder="To" aria-label="To month" readonly>
  <mat-datepicker #dt startView="multi-year" (monthSelected)="onToMonthSelected($event, dt)" (closed)="openAdfReport()"></mat-datepicker>
</payarc-filter-bar>

<payarc-section-card [flush]="true">
  <payarc-table class="st-table">
    <thead>
      <tr>
        <th [attr.aria-sort]="sortAriaFor('processing_date')">
          <button type="button" class="pa-th-sort" (click)="setSorting('processing_date')">Date
            <payarc-sort-icon [direction]="sortDirectionFor('processing_date')"></payarc-sort-icon></button></th>
        <th>Download</th>
        <th class="st-preview-col">Preview</th>
        <th class="num" [attr.aria-sort]="sortAriaFor('total_authorizations')">
          <button type="button" class="pa-th-sort" (click)="setSorting('total_authorizations')">Total Authorizations
            <payarc-sort-icon [direction]="sortDirectionFor('total_authorizations')"></payarc-sort-icon></button></th>
        <th class="num" [attr.aria-sort]="sortAriaFor('total_sales_count')">
          <button type="button" class="pa-th-sort" (click)="setSorting('total_sales_count')">Total Captured Sales
            <payarc-sort-icon [direction]="sortDirectionFor('total_sales_count')"></payarc-sort-icon></button></th>
        <th class="num" [attr.aria-sort]="sortAriaFor('total_sales_volume')">
          <button type="button" class="pa-th-sort" (click)="setSorting('total_sales_volume')">Total Sales Volume
            <payarc-sort-icon [direction]="sortDirectionFor('total_sales_volume')"></payarc-sort-icon></button></th>
        <th class="num" [attr.aria-sort]="sortAriaFor('total_refund_count')">
          <button type="button" class="pa-th-sort" (click)="setSorting('total_refund_count')">Total Refunds
            <payarc-sort-icon [direction]="sortDirectionFor('total_refund_count')"></payarc-sort-icon></button></th>
        <th class="num" [attr.aria-sort]="sortAriaFor('total_refund_amount')">
          <button type="button" class="pa-th-sort" (click)="setSorting('total_refund_amount')">Total Refund Volume
            <payarc-sort-icon [direction]="sortDirectionFor('total_refund_amount')"></payarc-sort-icon></button></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="loadFlag">
        <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
          <td *ngFor="let c of [1,2,3,4,5,6,7,8]"><span class="pa-skeleton-bar"></span></td>
        </tr>
      </ng-container>

      <tr *ngIf="!loadFlag && errorMsg">
        <td class="pa-table__state-cell" colspan="8">
          <payarc-empty-state [title]="requestFailed ? 'Unable to load statements' : 'No statements found'" [message]="errorMsg"></payarc-empty-state>
        </td>
      </tr>

      <ng-container *ngIf="!loadFlag && !errorMsg">
        <tr *ngFor="let statement of statementlist.data">
          <td data-th="Date">{{statement.processing_date | date: 'MM/dd/yyyy'}}</td>
          <td data-th="Download">
            <button type="button" class="st-link-btn" (click)="download_statement(statement.id)">PDF</button>
          </td>
          <td data-th="Preview" class="st-preview-col">
            <button type="button" class="st-link-btn st-preview-btn" (click)="view_statement(statement.id)" aria-label="Preview statement">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </button>
          </td>
          <td data-th="Total Authorizations" class="num">{{statement.total_authorizations || statement.total_authorizations == 0 ? (statement.total_authorizations | number) : '--' }}</td>
          <td data-th="Total Captured Sales" class="num">{{statement.total_sales_count || statement.total_sales_count == 0 ? (statement.total_sales_count | number) : '--' }}</td>
          <td data-th="Total Sales Volume" class="num">{{statement.total_sales_volume || statement.total_sales_volume == 0 ? (((statement.total_sales_volume) | currency:'USD':'symbol':'1.2-2') + ' USD') : '--'}}</td>
          <td data-th="Total Refunds" class="num">{{statement.total_refund_count || statement.total_refund_count == 0 ? (statement.total_refund_count | number) : '--' }}</td>
          <td data-th="Total Refund Volume" class="num">{{statement.total_refund_amount || statement.total_refund_amount == 0 ? (((statement.total_refund_amount) | currency:'USD':'symbol':'1.2-2') + ' USD') : '--'}}</td>
        </tr>
      </ng-container>
    </tbody>
  </payarc-table>

  <div class="st-pager-row" *ngIf="!loadFlag && !errorMsg && metadata?.['total']">
    <label class="st-pager-row__limit">
      Rows per page
      <select class="pa-input" [(ngModel)]="limit" (change)="openAdfReport()">
        <option *ngFor="let no of limitArray" [ngValue]="no">{{ no }}</option>
      </select>
    </label>
    <payarc-pager
      [rangeLabel]="pagerRangeLabel"
      [pages]="pagerPages"
      [currentPage]="currentPage"
      [disablePrev]="currentPage <= 1"
      [disableNext]="currentPage >= totalPages"
      (prev)="pagerPrev()"
      (next)="pagerNext()"
      (pageSelect)="pagerSelect($event)"
    ></payarc-pager>
  </div>
</payarc-section-card>
